import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2b820093"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=2b820093&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports